import { useState } from 'react';
import Logo from '../assets/Logo';

// ── NAV LINKS ─ edit labels/keys here ──────────────────────────
const NAV_LINKS = [
  { key: 'home',     label: 'Hem' },
  { key: 'services', label: 'Tjänster' },
  { key: 'about',    label: 'Om oss' },
  { key: 'contact',  label: 'Kontakt' },
];

export default function Navbar({ currentPage, navigate }) {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleNav = (key) => {
    navigate(key);
    setMenuOpen(false);
  };

  return (
    <nav>
      <button className="logo" onClick={() => handleNav('home')}>
        <span className="logo-svg nav-logo-svg">
          <Logo height={56} />
        </span>
      </button>

      <div className={`nav-links${menuOpen ? ' open' : ''}`}>
        {NAV_LINKS.map(({ key, label }) => (
          <button
            key={key}
            id={`nb-${key}`}
            className={`nb${currentPage === key ? ' active' : ''}`}
            onClick={() => handleNav(key)}
          >
            {label}
          </button>
        ))}
        <button className="ncta" onClick={() => handleNav('contact')}>
          Kontakta oss
        </button>
      </div>

      <button
        className="hbg"
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Meny"
      >
        <span /><span /><span />
      </button>
    </nav>
  );
}
